export function shortString(str: string | any, firstValues: number, secondValues: number) {
  const splittingArray = str.split('');
  const firstStr = splittingArray.slice(0, firstValues);
  const secondStr = splittingArray.slice(secondValues);
  const newStr = `${firstStr.join('')}...${secondStr.join('')}`;

  return newStr;
}
